<div tabindex="0" #main class="main" style="flex-direction: column;">
  <ngx-loading [show]="loading"></ngx-loading>
  <div class="editor" [formGroup]="form" style="flex-direction: row; justify-content: space-between;">
    <div style="width: 80%; padding: 0 2% 0 0;">
      <div class="editor-mode-toggle">
        <div class="mode-toggle" style="display: flex; flex-direction: row;">
          <button
          (onShown)="onHoverTipShow()"
          (onHidden)="onHoverTipHide()"
          [isDisabled]="disableHoverTips"
          tooltip="Click here to open the Torch Editor. This is where you will customize the flashlight portion of your show"
          (click)="changeEditorMode('TORCH')"
          [ngClass]="{ active: editorMode === 'TORCH' }"
          type="button"
          >
            Torch
          </button>
          <button
          (onShown)="onHoverTipShow()"
          (onHidden)="onHoverTipHide()"
          [isDisabled]="disableHoverTips"
          tooltip="Click here to open the Screen Editor. This is where you will customize the on-screen content of your show"
          (click)="changeEditorMode('SCREEN')"
          [ngClass]="{ active: editorMode === 'SCREEN' }"
          [disabled]="shouldFreeze"
          type="button"
          >
            Screen
          </button>
          <div *ngIf="hasSiteManagement && editorMode === 'TORCH' && lightShowTypeCode == '1A' " style="display: flex; flex-direction: row; padding: 8px;">
            <chunky-check-box (changed)="toggleSaveLibTrackChanges($event)"></chunky-check-box>
            <span style="margin-left: 7px;">Save Changes to Library Track</span>
          </div>

        </div>
        <div
          (onShown)="onHoverTipShow()"
          (onHidden)="onHoverTipHide()"
          [isDisabled]="disableHoverTips"
          tooltip="Saves the current progress on your show. Next time you log in, you can pick up where you left off"
          *ngIf="!lightShowId" class="editor-save">
          <button (click)="saveCurrentLightShowProgress()">
            Save
          </button>
        </div>
      </div>

      <app-mp3-player
        (onShown)="onHoverTipShow()"
        (onHidden)="onHoverTipHide()"
        [isDisabled]="disableHoverTips"
        [disableHoverTips]="disableHoverTips"
        tooltip="Timeline where your images, colors, sound effects, and torches will appear. Drag the Playback Scrubber (the red line) along the Timeline to start playback from any point in the song. Drag the segments to move them or edit them below. Segments of the same kind cannot overlap"
        #player
        style="grid-column: 1/4"
        canCropEnd="true"
        [cropEndPercent]="form.get('cropEndPercent').value"
        [url]="mp3Url"
        [segmentsFormArray]="this.form.get('customModeData.segments')"
        [selectedSegmentIndex]="
          form.get('customModeData.selectedSegmentIndex').value || 0
        "
        [currentUserEngine]="lightShowOwnerEngine ?? currentUserEngine"
        [currentSoundEffect]="currentSoundEffect"
        [timelineError]="timelineError"
        [editorMode]="editorMode"
        [segmentMode]="segmentMode"
        [torchArray]="trackOperations"
        [main]="main"
        (segmentSelected)="segmentSelected($event)"
        (updateFades)="updateFadeInAndFadeOut()"
        (playPositionChanged)="player.playPosition = $event"
        [useForLightshowEditor]="true"
        [venueId]="venueId"
        (segmentDropped)="onSegmentDropped($event)"
      >
      </app-mp3-player>

      <div
        *ngIf="editorMode ==='SCREEN'"
        tooltip="Click here to add a new segment to the Timeline"
        (onShown)="onHoverTipShow()"
        (onHidden)="onHoverTipHide()"
        [isDisabled]="disableHoverTips"
        [disabled]="!track"
        (click)="addSegment()"
        class="addbtn"
        >
      </div>

      <div
        *ngIf="editorMode === 'TORCH'"
        tooltip="Click here to add a new segment to the Timeline"
        (onShown)="onHoverTipShow()"
        (onHidden)="onHoverTipHide()"
        [isDisabled]="disableHoverTips"
        [disabled]="!track"
        (click)="addTorchSegment()"
        class="addbtn"
        >
      </div>

      <div style="display:inline;">
        <app-error-tooltip style="float: left;" #timelineError marginTop="10px"> </app-error-tooltip>
        <div style="float:right; margin-top: 10px;">
          <span class="color-black">Light Show Size: </span>
          <div tooltip="Light shows cannot exceed 20 MB in size. You are currently using {{lightShowSize}} MB out of the available 20 MB" [style.background-color]="lightShowSizeColor" id="rectangle"> </div>
        </div>
        <div style="text-align: center; margin-top: 10px;">
          <button
            class="form-button"
            style="border: 1px solid black; border-radius: 3px;"
            (click)="clearAllSegments()"
            type="button"
          >Clear All</button>
        </div>
      </div>

      <!-- TORCH EDITOR -->
      <app-lightshow-torch-editor
        *ngIf="editorMode === 'TORCH'"
        [lightshowOperations]="trackOperations"
        [playPosition]="player.playPosition"
        [player]="player.playerRootRef.nativeElement"
        [totalDuration]="player.totalDuration"
        [main]="main"
        [state]="state"
        [timelineError]="timelineError"
        [track]="track"
        [form]="form"
        [canProgramCustomTracks]="canProgramCustomTracks"
        [disableHoverTips]="disableHoverTips"
      >
      </app-lightshow-torch-editor>

      <!-- SCREEN EDITOR -->
      <div *ngIf="editorMode === 'SCREEN'">
        <div class="lightshow-timeline">
          <div
            (onShown)="onHoverTipShow()"
            (onHidden)="onHoverTipHide()"
            [isDisabled]="disableHoverTips"
            tooltip="Light Show Segment List. Contains all of the color and image segments that compose your light show. You can select a segment and edit the start time and duration, or delete the segment"
            #timeline
            class="timeline"
            [ngStyle]="{
              'overflow-x': segments.length > 6 ? 'scroll' : 'hidden'
            }"
          >
            <div
              #segments
              *ngFor="
                let segment of form.get('customModeData.segments')['controls'];
                let i = index
              "
              class="item"
              [ngClass]="{
                'error-segment': !form.get('customModeData.segments').controls[i].valid,

                'selected-segment': compareSegments(
                segment.value,
                selectedSegment ? selectedSegment.value : null
              ),

              'opacity-1': !compareSegments(
                segment.value,
                selectedSegment ? selectedSegment.value : null
              )}"
              (click)="segmentSelected({ index: i })"
              (mouseenter)="segment.value.hover = true"
              (mouseleave)="segment.value.hover = false"
              [style.border]="segment.value.hidden ? '3px solid orange' : compareSegments(segment.value, selectedSegment ? selectedSegment.value : null) ? '1.5px solid black' : none"
            >
              <div
                class="delete-btn center-items"
                (click)="player.deleteSegment(i)"
                style="z-index: 1;"
              >
                <span>+</span>
              </div>
              <div *ngIf="segment.value.hover" (click)="player.hideSegment(i)">
                <img
                  *ngIf="!segment.value.hidden"
                  class="hide-btn"
                  src="../../../assets/app/media/img/icons/eye.png"
                  style="z-index: 1;">
                <img
                  *ngIf="segment.value.hidden"
                  class="hide-btn"
                  src="../../../assets/app/media/img/icons/eye_x.png"
                  style="z-index: 1;">
              </div>

              <img
                *ngIf="
                  segment.value.imageUrl && segment.value.colors.length === 0
                "
                [src]="segment.value.imageUrl"
                [ngStyle]="{ background: segment.value.imageBackgroundColor }"
                class="fill-parent"
                [style.filter]="segment.value.hover ? 'brightness(50%)' : none"
              />

              <div *ngIf="segment.value.colors.length > 0" class="color-block">
                <div
                  *ngFor="let color of segment.value.colors; let i = index"
                  [ngStyle]="{ 'background-color': color }"
                  class="color-container center-items"
                  [style.filter]="segment.value.hover ? 'brightness(50%)' : none"
                ></div>
              </div>

              <div
                *ngIf="segment.value.audioName && segment.value.audioUrl"
                class="audio-block fill-parent color-container center-items"
              >
                <div class="center-items fill-parent audio-info">
                  {{ segment.value.audioName }}
                </div>
              </div>
            </div>
          </div>
          <div class="edit">
            <div
              *ngIf="selectedSegment"
              class="time-control justify-content-evenly"
            >
              <div
                tooltip="Start time of the selected segment in seconds"
                (onShown)="onHoverTipShow()"
                (onHidden)="onHoverTipHide()"
                [isDisabled]="disableHoverTips"
              >
                <label for="start"> Start </label>
                <input
                  #start
                  id="start"
                  class="form-control"
                  type="number"
                  step="0.1"
                  [value]="selectedSegmentValue.position / 1000 | number: '1.2-2'"
                  (keypress)="preventAutoPlay($event)"
                  (change)="
                    setSelectedSegmentPosition($event.target.value * 1000)
                  "
                  (focus)="startFocus = true"
                  (blue)="startFocus = false"
                />
              </div>
              <div
                tooltip="Total duration of the selected segment in seconds"
                (onShown)="onHoverTipShow()"
                (onHidden)="onHoverTipHide()"
                [isDisabled]="disableHoverTips"
              >
                <label for="duration"> Duration </label>
                <input
                  #duration
                  id="duration"
                  class="form-control"
                  type="number"
                  step="0.1"
                  [disabled]="selectedSegmentValue.audioUrl"
                  [ngStyle]="{
                    cursor: selectedSegmentValue.audioUrl ? 'no-drop' : 'text'
                  }"
                  value="{{
                    (selectedSegmentValue.duration) /
                      1000 | number: '1.2-2'
                  }}"
                  (keypress)="preventAutoPlay($event)"
                  (change)="
                    setSelectedSegmentDuration($event.target.value * 1000)
                  "
                  (focus)="durationFocus = true"
                  (blur)="durationFocus = false"
                />
              </div>
              <div
                tooltip="Number of seconds an image or color will take to fade in completely"
                (onShown)="onHoverTipShow()"
                (onHidden)="onHoverTipHide()"
                [isDisabled]="disableHoverTips"
                >
                <label for="fadeIn"> Fade In </label>
                <input
                  #fadeIn
                  id="fadeIn"
                  class="form-control"
                  type="number"
                  step="0.1"
                  value="0.00"
                  [disabled]="selectedSegmentValue.audioUrl"
                  [ngStyle]="{
                    cursor: selectedSegmentValue.audioUrl ? 'no-drop' : 'text'
                  }"
                  (keypress)="preventAutoPlay($event)"
                  (change)="
                    setSelectedSegmentFadeInOrFadeOut(
                      $event.target.value * 1000,
                      'fadeIn'
                    )
                  "
                  (focus)="fadeInFocus = true"
                  (blur)="fadeInFocus = false"
                />
              </div>
              <div
                tooltip="Number of seconds an image or color will take to fade out completely"
                (onShown)="onHoverTipShow()"
                (onHidden)="onHoverTipHide()"
                [isDisabled]="disableHoverTips"
                >
                <label for="fadeOut"> Fade Out </label>
                <input
                  #fadeOut
                  id="fadeOut"
                  class="form-control"
                  type="number"
                  step="0.1"
                  value="0.00"
                  [disabled]="selectedSegmentValue.audioUrl"
                  [ngStyle]="{
                    cursor: selectedSegmentValue.audioUrl ? 'no-drop' : 'text'
                  }"
                  (keypress)="preventAutoPlay($event)"
                  (change)="
                    setSelectedSegmentFadeInOrFadeOut(
                      $event.target.value * 1000,
                      'fadeOut'
                    )
                  "
                  (focus)="fadeOutFocus = true"
                  (blur)="fadeOutFocus = false"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="tab-container">
          <ul class="nav">
            <li
              (onShown)="onHoverTipShow()"
              (onHidden)="onHoverTipHide()"
              [isDisabled]="disableHoverTips"
              tooltip="Image Library. Add images you want to use in your light show here and assign them to a segment in the Timeline above. Select or create a segment on the Timeline, then click an image. JPG, PNG, and GIF image types are supported. The recommended aspect ratio is 16:9 (1920 x 1080)"            class="item center-items"
              [ngClass]="{ selected: tabToShow === 'images' }"
              (click)="changeSegmentMode('IMAGE')"
            >
              IMAGES
            </li>
            <li
              (onShown)="onHoverTipShow()"
              (onHidden)="onHoverTipHide()"
              [isDisabled]="disableHoverTips"
              tooltip="Color Library. Add colors you want to use in your light show here and assign them to a segment in the Timeline above. Select or create a segment on the Timeline, then click a color. Solid Colors stay the same color throughout the duration of the segment. Smart Colors cycle through each color in sync with the torch. Smart Colors are recommended" class="item center-items"
              [ngClass]="{ selected: tabToShow === 'colors' }"
              (click)="changeSegmentMode('COLOR')"
            >
              COLORS
            </li>
            <li
              (onShown)="onHoverTipShow()"
              (onHidden)="onHoverTipHide()"
              [isDisabled]="disableHoverTips"
              tooltip="Sound Effect Library. Choose or Add Sound Effects you want to be played directly from the audiences phone here. Select or create a segment on the Timeline, then click an effect. The duration of Sound Effects cannot be changed"            class="item center-items"
              [ngClass]="{ selected: tabToShow === 'audio' }"
              (click)="changeSegmentMode('SOUND')"
            >
              SOUNDS
            </li>
          </ul>

          <app-error-tooltip #libraryError marginBottom="10px">
          </app-error-tooltip>

          <div class="content">
            <div #imagesContainer class="item" [hidden]="tabToShow !== 'images'">
              <div
                #imageElements
                class="square-container library-item"
                *ngFor="let image of imageLibrary; let i = index"
                [ngStyle]="{ background: image.imageBackgroundColor }"
                [dndDraggable]="{ type: 'image', objectIndex: i }"
              >
                <div
                  class="menu-dots justify-content-evenly form-button"
                  [hidden]="imageIndexToHide === i"
                  (click)="
                    imageIndexToHide = i; invalidBackgroundColorString = false
                  "
                >
                  <div></div>
                  <div></div>
                  <div></div>
                </div>

                <img
                  style="object-fit: contain;"
                  [hidden]="imageIndexToHide === i"
                  [src]="image.url"
                  class="position-absolute"
                  (click)="setSegmentImage(image)"
                />

                <div class="position-absolute" *ngIf="imageIndexToHide === i">
                  <div class="solid-color-form">
                    <div class="container-with-border">
                      <label>
                        Background
                        <img
                          src="../../assets/app/media/img/icons/info-icon.png"
                          class="tooltip-icon"
                          style="position: relative; top: -1px; height: 15px"
                          tooltip="Change the background color on .png images."
                          placement="bottom"
                        />
                      </label>
                      <div style="display:flex;">
                        <input
                          class="uppercase"
                          spellcheck="false"
                          #backgroundColorString
                          type="text"
                          [attr.disabled]="
                            !image?.name?.endsWith('.png') ? 'disabled' : null
                          "
                          [ngStyle]="{
                            cursor: !image?.name?.endsWith('.png')
                              ? 'no-drop'
                              : 'pointer'
                          }"
                          [value]="image.imageBackgroundColor"
                          (focus)="
                            onEnterColor(
                              'backgroundColorString',
                              backgroundColorString.value
                            )
                          "
                          (focusout)="
                            onSaveColor(
                              'backgroundColorString',
                              backgroundColorString.value
                            )
                          "
                        />

                        <input
                          *ngIf="image?.name?.endsWith('.png')"
                          class="uppercase drag"
                          #enterBackgroundColorString
                          autocomplete="off"
                          cpWidth="180px"
                          [colorPicker]="image.imageBackgroundColor"
                          [cpAlphaChannel]="'disabled'"
                          [cpDisableInput]="true"
                          (colorPickerChange)="
                            backgroundColorString.value = $event;
                            image.imageBackgroundColor = $event
                          "
                        />
                      </div>

                      <small
                        *ngIf="invalidBackgroundColorString"
                        class="solid-color-info-message"
                        >Invalid hex code</small
                      >
                    </div>

                    <div class="justify-content-between">
                      <div class="form-button" (click)="deleteImage(image)">
                        Delete
                      </div>
                      <div class="form-button">
                        <label for="replace-btn" class="form-button" style="font-size: 12px;">Replace</label>
                        <input
                          [hidden]="true"
                          type="file"
                          id="replace-btn"
                          class="inputfile inputfile-3"
                          accept="image/*"
                          multiple="false"
                          (change)="addImageToLibrary($event.target.files, i)"
                        />
                      </div>
                      <div
                        class="form-button"
                        (click)="
                          changeImageBackgroundColor(
                            i,
                            backgroundColorString.value
                          )
                        "
                      >
                        Save
                      </div>
                    </div>
                  </div>
                </div>

                <div class="position-hack"></div>
              </div>

              <div
                #dropZone
                class="drop-zone square-container image-upload library-item"
              >
                <ngx-loading [show]="uploadingImageFile"></ngx-loading>

                <div
                  class="drop-zone-message"
                  *ngIf="isOnTopOfDragZone; else notOverDropZone"
                >
                  Drop image to begin upload
                </div>
                <div class="position-hack"></div>

                <ng-template #notOverDropZone>
                  <label for="upload-btn" class="position-absolute"> </label>
                  <input
                    type="file"
                    id="upload-btn"
                    class="inputfile inputfile-3"
                    accept="image/*"
                    multiple="false"
                    (change)="addImageToLibrary($event.target.files)"
                  />
                </ng-template>
              </div>
            </div>

            <div #colorsContainer class="item" [hidden]="tabToShow !== 'colors'">
              <div
                #colorElements
                *ngFor="let colorObject of colorsLibrary; let i = index"
                class="square-container library-item"
                [dndDraggable]="{ type: 'color', objectIndex: i }"
              >
                <div
                  class="menu-dots justify-content-evenly form-button"
                  [hidden]="colorIndexToHide === i"
                  (click)="colorIndexToHide = i; invalidEditColorString = false"
                >
                  <div></div>
                  <div></div>
                  <div></div>
                </div>

                <div
                  [hidden]="colorIndexToHide === i"
                  *ngIf="colorObject.type === 'solid'"
                  class="color-block position-absolute"
                >
                  <div
                    class="color-container center-items"
                    [ngStyle]="{ 'background-color': colorObject.color }"
                    (click)="setSegmentColor([colorObject.color])"
                  >
                    <span class="center-items">
                      {{ colorObject.color | uppercase }}
                    </span>
                  </div>
                </div>

                <div
                  class="position-absolute"
                  *ngIf="colorIndexToHide === i && colorObject.type === 'solid'"
                >
                  <div class="solid-color-form" [hidden]="showSmartColorEditForm">
                    <div class="container-with-border">
                      <label
                        class="form-button"
                        (click)="showSmartColorEditForm = true"
                        >+ Smart Color</label
                      >
                      <div style="display: flex;">
                        <input
                          class="uppercase"
                          spellcheck="false"
                          autocomplete="off"
                          type="text"
                          #editColorString
                          pattern="^[a-fA-F\d]+$"
                          [value]="colorObject.color"
                          (focus)="
                            onEnterColor('editColorString', editColorString.value)
                          "
                          (focusout)="
                            onSaveColor('editColorString', editColorString.value)
                          "
                          value="#"
                          [ngStyle]="{ cursor: 'pointer' }"
                        />

                        <input
                          #enterEditColorString
                          class="uppercase drag"
                          spellcheck="false"
                          cpWidth="180px"
                          [colorPicker]="colorObject.color"
                          [cpAlphaChannel]="'disabled'"
                          [cpDisableInput]="true"
                          (colorPickerChange)="editColorString.value = $event"
                        />
                      </div>
                      <small
                        *ngIf="invalidEditColorString"
                        class="solid-color-info-message"
                        >Invalid hex code</small
                      >
                    </div>

                    <div class="justify-content-between">
                      <div class="form-button" (click)="deleteColor(i)">
                        Delete
                      </div>
                      <div
                        class="form-button"
                        (click)="editSolidColor(i, editColorString.value)"
                      >
                        Save
                      </div>
                    </div>
                  </div>

                  <app-smart-color-form
                    *ngIf="showSmartColorEditForm"
                    [colors]="[colorObject.color]"
                    [index]="i"
                    (submitForm)="editSmartColor(i, $event)"
                    (deleteColor)="deleteColor($event)"
                  >
                  </app-smart-color-form>
                </div>

                <div
                  [hidden]="colorIndexToHide === i"
                  *ngIf="colorObject.type === 'smart'"
                  class="position-absolute"
                >
                  <div
                    (click)="setSegmentColor(colorObject.colors)"
                    class="color-block"
                  >
                    <div
                      *ngFor="let color of colorObject.colors"
                      [ngStyle]="{ 'background-color': color }"
                      class="color-container center-items"
                    >
                      <span class="center-items">{{ color | uppercase }}</span>
                    </div>
                  </div>
                </div>
                <div
                  [hidden]="colorIndexToHide === i"
                  *ngIf="colorObject.type === 'strobe'"
                  class="position-absolute"
                >
                  <div
                    (click)="setSegmentColor(colorObject.colors, true)"
                    class="color-block"
                  >
                    <div
                      *ngFor="let color of colorObject.colors"
                      [ngStyle]="{ 'background-color': color }"
                      class="color-container center-items"
                    >
                      <span class="center-items">{{ color | uppercase }}</span>
                    </div>
                  </div>
                </div>

                <div
                  class="position-absolute"
                  *ngIf="colorIndexToHide === i && colorObject.type === 'smart'"
                >
                  <app-smart-color-form
                    (submitForm)="editSmartColor(i, $event)"
                    (deleteColor)="deleteColor($event)"
                    [colors]="colorObject.colors"
                    [index]="i"
                  >
                  </app-smart-color-form>
                </div>
                <div
                  class="position-absolute"
                  *ngIf="colorIndexToHide === i && colorObject.type === 'strobe'"
                >
                  <app-screen-strobe-form
                    (submitForm)="editStrobeColor(i, $event)"
                    (deleteColor)="deleteColor($event)"
                    [colors]="colorObject.colors"
                    [index]="i"
                  >
                  </app-screen-strobe-form>
                </div>
                <div class="position-hack"></div>
              </div>

              <div
                [hidden]="addingColor"
                class="square-container image-upload library-item"
                (click)="addingColor = true"
              >
                <div class="position-hack"></div>
              </div>

              <div *ngIf="addingColor" class="square-container color-form">
                <div class="position-hack"></div>
                <div class="content">
                  <div
                    class="form-background justify-content-evenly"
                    [hidden]="selectedColorMode"
                  >
                    <div
                      class="text-form-btn form-button"
                      (click)="
                        selectedColorMode = 'solid'; invalidColorString = false
                      "
                    >
                      Solid Color
                    </div>

                    <div class="form-divider justify-content-evenly">
                      <div class="line"></div>

                      <span>or</span>

                      <div class="line"></div>
                    </div>

                    <div
                      class="text-form-btn form-button"
                      (click)="selectedColorMode = 'smart'"
                    >
                      Smart Color
                    </div>
                    <div class="form-divider justify-content-evenly">
                      <div class="line"></div>

                      <span>or</span>

                      <div class="line"></div>
                    </div>

                    <div
                      class="text-form-btn form-button"
                      (click)="selectedColorMode = 'strobe'"
                    >
                      Strobe Color
                    </div>
                  </div>


                  <div
                    *ngIf="selectedColorMode === 'solid'"
                    class="solid-color-form"
                  >
                    <div class="container-with-border">
                      <label>Color</label>
                      <div style="display: flex;">
                        <input
                          class="uppercase"
                          spellcheck="false"
                          autocomplete="off"
                          type="text"
                          #colorString
                          (focus)="onEnterColor('colorString', colorString.value)"
                          (focusout)="
                            onSaveColor('colorString', colorString.value)
                          "
                          value="#"
                          [ngStyle]="{ cursor: 'pointer' }"
                        />

                        <input
                          #enterColorString
                          class="uppercase drag"
                          spellcheck="false"
                          cpWidth="180px"
                          [colorPicker]="colorString.value"
                          [cpAlphaChannel]="'disabled'"
                          [cpDisableInput]="true"
                          (colorPickerChange)="colorString.value = $event"
                        />
                      </div>

                      <small
                        *ngIf="invalidColorString"
                        class="solid-color-info-message"
                        >Invalid hex code</small
                      >
                    </div>

                    <div class="justify-content-between">
                      <div
                        class="form-button"
                        (click)="addingColor = false; selectedColorMode = null"
                      >
                        Cancel
                      </div>
                      <div
                        class="form-button"
                        (click)="addColorToLibrary([colorString.value])"
                      >
                        Save
                      </div>
                    </div>
                  </div>

                  <app-smart-color-form
                    *ngIf="selectedColorMode === 'smart'"
                    (submitForm)="addColorToLibrary($event)"
                    (cancel)="addingColor = false; selectedColorMode = null"
                  >
                  </app-smart-color-form>

                  <app-screen-strobe-form
                    *ngIf="selectedColorMode === 'strobe'"
                    (submitForm)="addColorToLibrary($event, true)"
                    (cancel)="addingColor = false; selectedColorMode = null"
                  >
                  </app-screen-strobe-form>
                </div>
              </div>
            </div>

            <div
              class="item"
              [hidden]="tabToShow !== 'audio'"
              [ngStyle]="{
                'overflow-y':
                  soundEffects && soundEffects.length > 3 ? 'scroll' : 'hidden'
              }"
            >
              <div
                class="square-container library-item"
                background="black"
              >
                <div class="audio-block position-absolute center-items" (click)="setSegmentSoundEffect(vibrateSoundEffect)">
                  <div style="font-size: 1.2em;">VIBRATE</div>
                  <!-- <app-sound-effect-player
                    (click)="setSegmentSoundEffect(se)"
                    [hidden]="soundEffectIndexToHide === i"
                    [soundEffect]="se"
                    [state]="state"
                  >
                  </app-sound-effect-player> -->
                </div>

                <div class="position-hack"></div>
              </div>

              <div
                class="square-container library-item"
                *ngFor="let se of soundEffects; let i = index"
                background="black"
                [dndDraggable]="{ type: 'sound', objectIndex: i }"
              >
                <div class="audio-block position-absolute">
                  <app-sound-effect-player
                    (click)="setSegmentSoundEffect(se)"
                    [hidden]="soundEffectIndexToHide === i"
                    [soundEffect]="se"
                    [state]="state"
                    (onDelete)="deleteSoundEffect(i)"
                  >
                  </app-sound-effect-player>
                </div>

                <div class="position-hack"></div>
              </div>

              <div class="square-container image-upload library-item">
                <ngx-loading [show]="uploadingSoundEffect"></ngx-loading>
                <label
                  class="position-absolute"
                  for="mp3Upload"
                  style="width:100%; margin-bottom: 0"
                >
                </label>
                <input
                  id="mp3Upload"
                  type="file"
                  class="inputfile inputfile-3"
                  accept="audio/mpeg"
                  multiple="false"
                  (change)="uploadSoundEffect($event.target.files)"
                />

                <div class="position-hack"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <select
        *ngIf="editorMode === 'TORCH' && enableVenueEdit" style="margin-bottom: 15px;"
        (change)="venueChange()"
        #venueSelect
        class="form-control m-input"
        [ngModelOptions]="{standalone: true}"
        [(ngModel)]="venueId" id="venueSelect"
        name="venues">
        <option selected value="0">-- No Venue --</option>
        <option
          style="color:black;"
          *ngFor="let venue of (userVenues | orderBy: 'name')"
          [ngValue]="venue.venueId"
          [selected]="venue.venueId === venueId">
          {{ venue.name }}
        </option>
      </select>
    </div>

    <div>
      <div style="display: flex; flex-direction: column; justify-content: space-between;">
        <app-preview
          [state]="state"
          [colorToDisplay]="colorToDisplay"
          [colorSegmentOpacity]="colorSegmentOpacity"
          [imageSegmentOpacity]="imageSegmentOpacity"
          [selectedColorSegment]="selectedColorSegment"
          [selectedImageSegment]="selectedImageSegment"
          (onShown)="onHoverTipShow()"
          (onHidden)="onHoverTipHide()"
          [isDisabled]="disableHoverTips"
          tooltip="This represents the screen and torch. Click the play button to see your light show previewed here"
        >
        </app-preview>

        <div *ngIf="showFullScreenPreview" #preview>
          <app-fullscreen-preview
            [state]="state"
            [colorToDisplay]="colorToDisplay"
            [colorSegmentOpacity]="colorSegmentOpacity"
            [imageSegmentOpacity]="imageSegmentOpacity"
            [selectedColorSegment]="selectedColorSegment"
            [selectedImageSegment]="selectedImageSegment"
            [playPosition]="player.playPosition"
            [isPlaying]="player.isPlaying"
            [mp3Url]="mp3Url"
            [duration]="track.duration"
            (changePlayPosition)="player.seekPosition($event / 1000)"
            (play)="player.play()"
            (pause)="player.pause()"
          >
          </app-fullscreen-preview>
        </div>
      </div>
    </div>
  </div>

  <div style="display: flex; justify-content: space-between; padding: 0% 3% 0 3%;">
    <app-lightshow-torch-instructions *ngIf="editorMode === 'TORCH'">
    </app-lightshow-torch-instructions>
    <div>
      <a
      *ngIf="!disableHoverTips"
      (click)="toggleHoverTips()"
      #disableToolTip="bs-tooltip"
      placement="bottom"
      tooltip="Click here to turn off tips. You can always turn them back on if you need more help!"
      style="font-weight: bold; font-size: large;"
      class="item center-items"
      [ngClass]="{ 'highlight-tip-disable': hoverTipShowing }"
      href="#" >
        Disable Hover Tips
      </a>
      <a
        *ngIf="disableHoverTips"
        (click)="toggleHoverTips()"
        [autoClose]="false"
        href="#"
        class="item center-items"
        style="color: gray; font-size: large;">
        Enable Hover Tips
      </a>
    </div>
  </div>
<!-- VENUE START-->
  <div *ngIf="editorMode === 'TORCH' && venue && enableVenueEdit" class="venue-table" style="padding: 2% 3% 0 3%; margin: 0px;">
    <ngx-loading [show]="loading"></ngx-loading>
    <div class="table-cell">

      <!-- GROUP SECTION START -->
      <div class="data-row-col" style="margin-right: 15px;">

        <div class="data-row">
          <div class="data-row-content">
            <div class="content-cell" style="width: 100%; overflow-x: hidden;">
              <div class="cell-row">
                <div class="section-group-container">
                  <div *ngIf="venue" class="section-container" style="overflow-x: hidden;">
                    <div
                      *ngFor="let section of venue.venueSections"
                      class="align-center"
                      [ngClass]="{ 'selected-list-item': section.selected, 'list-item': !section.selected}"
                      (click)="selectSection(section);">
                      <span onselectstart="return false">{{section.name}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cell-row">
                <button [disabled]="state.isPlaying" class="btn dark-btn" (click)="deselectSections()">
                  Deselect All
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="data-row">
          <div class="data-row-content">
            <div class="content-cell" style="width: 100%; overflow-x: hidden;">
              <div class="cell-row">
                <div class="section-group-container">
                  <div *ngIf="venue" class="section-container" style="overflow-x: hidden;">
                    <div
                      *ngFor="let group of venue.venueGroups"
                      class="align-center"
                      [ngClass]="{ 'selected-list-item': group === selectedGroup, 'list-item': group !== selectedGroup }"
                      (click)="selectGroup(group);">
                      <span onselectstart="return false">{{group}}</span>
                    </div>
                  </div>
                  <div class="cell-row" style="justify-content: space-evenly;">
                    <button [disabled]="newGroupName == ''" class="btn dark-btn" (click)="createNewGroup()" style="width: 40%">
                      + Group
                    </button>
                    <input
                      type="text"
                      style="color: black; width: 50%; margin: 0;"
                      placeholder="New Group Name"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="newGroupName"
                      class="searchtext"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--<div class="data-row">
          <div class="data-row-content">
            <div class="content-cell" >
              <div class="cell-row">
                <div class="section-group-container">
                  <div *ngIf="venue" class="section-container" >
                    <div
                      *ngFor="let group of venue.venueGroups"
                      class="align-center"
                      [ngClass]="{ 'selected-list-item': group === selectedGroup, 'list-item': group !== selectedGroup }"
                      (click)="selectGroup(group);">
                      <span onselectstart="return false">{{group}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cell-row">
                <button [disabled]="newGroupName == ''" class="btn dark-btn" (click)="createNewGroup()">
                  + Sequence
                </button>
                <div class="input-with-icon align-row" style="border: 1px solid rgba(0,0,0,.1);">
                  <input
                    type="text"
                    class="color-black"
                    placeholder="New Sequence Name"
                    class="searchtext"
                  />
                  <button class="section-group-delete"><img alt=""
                    src="assets/app/media/img/tools/delete.png"
                    (click)="deleteSelectedGroup()"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div> -->

      </div>
      <!-- GROUP SECTION END -->

      <!-- IMAGE START -->
      <div class="data-row">
        <div class="data-row-content ">
          <div class="content-cell" style="width: 100%; overflow-x: hidden;">
            <div class="cell-row">
              <div class="img-container align-center">
                <div *ngIf="venue && venue.imageUrl !== ''"  class="canvasImageContainer">
                  <canvas
                  width="1536"
                  height="864"
                  class="venueCanvas"
                  (mousemove)="loadCanvas();"
                  #venueRef>
                    Your browser does not support HTML5 canvas :(
                  </canvas>
                  <img
                  (load)="loadCanvas()"
                  onselectstart="return false"
                  style='width: 100%; height: auto;'
                  class="image"
                  alt="" [src]="venue.imageUrl"
                  [style.opacity]="opacity / 100"
                  onerror="if (this.src != 'assets/app/media/img/error/img-not-found.png')
                    this.src = 'assets/app/media/img/error/img-not-found.png';">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- IMAGE END -->

    </div>
  </div>
 <!-- VENUE END-->
</div>
